import React from 'react'

import { useMemo, useState } from 'hooks'

import { CustomRangePicker } from 'components/molecules/CustomRangePicker'

import { GreyTabs } from 'components/organisms/GreyTabs/GreyTabs.jsx'

import { PERIODS_WITH_CUSTOM_RANGE as PERIODS } from 'app/pages/Securities/hooks'

import './PeriodSelectWithCustomRange.css'

const PeriodSelectWithCustomRange = ({ selectedPeriod, handlePeriodSelect }): JSX.Element => {
  const [showCustomRangePicker, setShowCustomRangePicker] = useState(false)

  const tabs = useMemo(
    () => [
      { title: '1W', id: PERIODS.WEEK, isActive: selectedPeriod === PERIODS.WEEK, 'data-test-id': PERIODS.WEEK },
      { title: '1M', id: PERIODS.MONTH, isActive: selectedPeriod === PERIODS.MONTH, 'data-test-id': PERIODS.MONTH },
      {
        title: '6M',
        id: PERIODS.SIX_MONTHS,
        isActive: selectedPeriod === PERIODS.SIX_MONTHS,
        'data-test-id': PERIODS.SIX_MONTHS,
      },
      { title: '1Y', id: PERIODS.YEAR, isActive: selectedPeriod === PERIODS.YEAR, 'data-test-id': PERIODS.YEAR },
      { title: 'Max', id: PERIODS.MAX, isActive: selectedPeriod === PERIODS.MAX, 'data-test-id': PERIODS.MAX },
      // { title: 'Range', id: PERIODS.RANGE, isActive: selectedPeriod === PERIODS.RANGE, 'data-test-id': PERIODS.RANGE },
    ],
    [selectedPeriod],
  )

  return (
    <div className="PeriodSelect-Wrapper">
      <GreyTabs
        tabs={tabs}
        onChange={(tab) => {
          handlePeriodSelect(tab.id)
          if (tab.id === PERIODS.RANGE) {
            setShowCustomRangePicker(true)
          } else {
            setShowCustomRangePicker(false)
          }
        }}
        fullWidth
        textAlign="center"
      />
      {showCustomRangePicker && (
        <CustomRangePicker
          onClose={() => {
            setShowCustomRangePicker(false)
          }}
        />
      )}
    </div>
  )
}

export { PeriodSelectWithCustomRange }
